import React from 'react';
import packageJson from '../../../package.json';

export default () => {
  return <>{packageJson.version}</>;
};
